import React, { useEffect, useState } from 'react';
import { Modal, Text, BlockStack, TextField } from '@shopify/polaris';

const ConfirmAIStoryActionModal = ({
  isOpen,
  title = 'Confirm Action',
  message = 'Are you sure?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false,
  destructive = false,
  onConfirm,
  onClose,
  // Optional input in body
  showInput = false,
  inputLabel = 'Name',
  inputPlaceholder = '',
  initialInputValue = '',
}) => {
  const [value, setValue] = useState(initialInputValue || '');

  useEffect(() => {
    setValue(initialInputValue || '');
  }, [initialInputValue, isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={<div style={{ padding: '16px' }}><Text variant="headingMd" as="h2">{title}</Text></div>}
      primaryAction={{
        content: confirmText || 'Confirm',
        onAction: () => onConfirm && onConfirm(value),
        loading,
        destructive,
      }}
      secondaryActions={[
        {
          content: cancelText || 'Cancel',
          onAction: onClose,
        },
      ]}
      footer={<div style={{ padding: '16px' }} />}
    >
      <BlockStack gap="400">
        {message && <Text as="p" variant="bodyMd">{message}</Text>}
        {showInput && (
          <TextField
            label={inputLabel}
            value={value}
            onChange={setValue}
            placeholder={inputPlaceholder}
            autoComplete="off"
          />
        )}
      </BlockStack>
    </Modal>
  );
};

export default ConfirmAIStoryActionModal;


